/**
 * @file: ServiceSubjectType.ts
 * @author: eric <xuxiang@zhichetech.com>
 * @copyright: (c) 2019-2020 sichuan zhichetech co., ltd.
 */

export enum ServiceSubjectType {
  Fault = 'fault',
  Inspection = 'inspection',
  Construction = 'construction',
  Other = 'other',
}

export const ServiceSubjectTypeValueSet = new Set([
  ServiceSubjectType.Fault,
  ServiceSubjectType.Inspection,
  ServiceSubjectType.Construction,
  ServiceSubjectType.Other,
]);
